import { render, staticRenderFns } from "./indices-table.vue?vue&type=template&id=f6d26fa8&"
import script from "./indices-table.vue?vue&type=script&lang=js&"
export * from "./indices-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports